import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const HERO_BG = "https://customer-assets.emergentagent.com/job_qr-wash-earn/artifacts/phagavdd_1000004485.png";

export default function HeroSection() {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[90vh] flex items-center overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0a]/95 via-[#0a0a0a]/80 to-[#0a0a0a]/40" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 sm:px-12 lg:px-24 py-32">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-2xl"
        >
          <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-blue-500 mb-6">
            For DFW Car Wash Operators
          </span>
          <h1 className="text-5xl sm:text-6xl font-black tracking-tighter leading-none text-white mb-6">
            Bring in More Customers.{" "}
            <span className="text-blue-500">Get Paid Every Time.</span>
          </h1>
          <p className="text-lg text-neutral-400 leading-relaxed mb-10 max-w-lg">
            Join the AnyWash Pass monthly membership network. We send customers to your wash
            — you get paid weekly. No upfront costs, no contracts.
          </p>
          <a
            href="#contact"
            data-testid="hero-cta-button"
            className="inline-flex items-center gap-3 bg-blue-600 hover:bg-blue-500 text-white rounded-full px-8 py-4 transition-all duration-300 transform hover:-translate-y-1 shadow-[0_0_20px_rgba(37,99,235,0.3)] hover:shadow-[0_0_30px_rgba(37,99,235,0.5)] font-bold text-sm tracking-wide"
          >
            Get Started <ArrowRight className="w-4 h-4" />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
